var map = {
	"./dashboard.svg": "f782",
	"./delete.svg": "59a1",
	"./edit.svg": "aa46",
	"./exit-fullscreen.svg": "dbc7",
	"./eye.svg": "4df5",
	"./fee.svg": "251a",
	"./forecast.svg": "80a8",
	"./fullscreen.svg": "9921",
	"./history.svg": "c023",
	"./machine.svg": "7506",
	"./password.svg": "2a3d",
	"./project.svg": "69e4",
	"./run.svg": "c579",
	"./see.svg": "cd37",
	"./spectrum.svg": "98c3",
	"./team.svg": "64c9",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";